<template>
  <div>
    <KTCodePreview
      ><template v-slot:preview
        ><b-row
          ><b-col lg="3" md="3"
            ><b-form-group label="Pabrik" label-for="pabrik_id"
              ><b-form-select
                v-model="selectedPabrik"
                :options="pabrik"
                value-field="id_pabrik"
                text-field="nama_pabrik"
                id="pabrik_id"
                @change="loadPlant"
              ></b-form-select></b-form-group></b-col
          ><b-col lg="3" md="3"
            ><b-form-group label="Plant" label-for="plant_id"
              ><b-form-select
                v-model="selectedPlant"
                :options="plant"
                value-field="id_plant"
                text-field="nama_plant"
                id="plant_id"
                @change="loadEquipment"
              ></b-form-select></b-form-group></b-col
          ><b-col lg="3" md="3"
            ><b-form-group label="Equipment" label-for="equipment_id"
              ><b-form-select
                v-model="selectedEquipment"
                :options="equipment"
                value-field="id_equipment"
                text-field="nomor_equipment"
                id="equipment_id"
              ></b-form-select></b-form-group></b-col
          ><b-col lg="3" md="3"
            ><b-form-group label="Tahun" label-for="year"
              ><b-form-select
                v-model="selectedYear"
                :options="years"
                value-field="year"
                text-field="year"
                id="year"
              ></b-form-select></b-form-group></b-col
        ></b-row>
        <b-row>
          <b-col lg="3" md="3">
            <b-form-group>
              <b-button
                variant="outline-dark"
                class="mt-5"
                type="button"
                size="sm"
                @click="download_grafik"
              >
                <span class="svg-icon svg-icon-sm svg-icon-dark">
                  <i class="flaticon-download"></i>
                </span>
                Download Grafik
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ReportEquipment
            :pabrik="selectedPabrik"
            :plant="selectedPlant"
            :year="selectedYear"
            :equipment="selectedEquipment"
          ></ReportEquipment>
        </b-row>
        <b-row>
          <LastReport
            :pabrik="selectedPabrik"
            :plant="selectedPlant"
            :year="selectedYear"
            :equipment="selectedEquipment"
          ></LastReport>
        </b-row>
        <b-row>
          <DataDesain
            :pabrik="selectedPabrik"
            :plant="selectedPlant"
            :year="selectedYear"
            :equipment="selectedEquipment"
          ></DataDesain>
        </b-row>
      </template>
    </KTCodePreview>
  </div>
</template>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue'
import ApiService from '@/core/services/api.service'
import ReportEquipment from '@/components/dashboard/Report.vue'
import DataDesain from '@/components/dashboard/DataDesain.vue'
import LastReport from '@/components/dashboard/LastReport.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'NewDashboard',
  components: {
    KTCodePreview,
    ReportEquipment,
    DataDesain,
    LastReport,
  },
  computed: {
    ...mapGetters(['layoutConfig']),
    years() {
      const year = new Date().getFullYear()
      return Array.from({ length: year - 2019 }, (value, index) => 2020 + index)
    },
  },
  data() {
    return {
      selectedPabrik: 0,
      pabrik: [],
      selectedPlant: 0,
      plant: [],
      selectedYear: 2022,
      equipment: [],
      selectedEquipment: 0,
    }
  },
  created() {
    this.selectedYear = new Date().getFullYear()
    this.loadPabrik()
  },
  methods: {
    async loadPabrik() {
      await ApiService.get('/master/pabrik/all')
        .then(({ data }) => {
          if (data.status == 'ok') {
            this.pabrik = data.data
            this.selectedPabrik = this.pabrik[0].id_pabrik

            this.loadPlant()
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },
    async loadPlant() {
      await ApiService.get(
        '/master/plant/all?pabrik_id=' + this.selectedPabrik + '&sortBy=nama_plant&sortDesc=ASC'
      )
        .then(({ data }) => {
          if (data.status == 'ok') {
            this.plant = []
            this.plant.push({ id_plant: 0, nama_plant: 'All Plant' })
            this.plant = this.plant.concat(data.data.data)
            this.selectedPlant = this.plant[0].id_plant
            this.loadEquipment()
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },
    async loadEquipment() {
      await ApiService.get(
        '/master/equipment/getequipment?plant_id=' +
          this.selectedPlant +
          '&sortBy=nama_equipment&sortDesc=ASC'
      )
        .then(({ data }) => {
          this.equipment = []
          this.equipment.push({
            id_equipment: 0,
            nomor_equipment: 'All Equipment',
          })
          if (data.equipment.length > 0) {
            this.equipment = this.equipment.concat(data.equipment)
            this.selectedEquipment = this.equipment[0].id_equipment
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },

    // :pabrik="selectedPabrik"
    // :plant="selectedPlant"
    // :year="selectedYear"
    // :equipment="selectedEquipment"

    download_grafik() {
      const image_report_dashboard_risk = document.createElement('a')
      const image_report_dashboard_equipment = document.createElement('a')
      const image_report_dashboard_part = document.createElement('a')
      const image_report_dashboard_status = document.createElement('a')
      const image_report_dashboard_equipment_type = document.createElement('a')
      const image_report_dashboard_month = document.createElement('a')
      const image_dashboard_kritis = document.createElement('a')

      const report_dashboard_risk = document.getElementById('report-dashboard-risk')
      const report_dashboard_equipment = document.getElementById('report-dashboard-equipment')
      const report_dashboard_part = document.getElementById('report-dashboard-part')
      const report_dashboard_status = document.getElementById('report-dashboard-status')
      const report_dashboard_equipment_type = document.getElementById(
        'report-dashboard-equipment-type'
      )
      const report_dashboard_month = document.getElementById('report-dashboard-month')
      const report_dashboard_kritis = document.getElementById('report-dashboard-kritis')

      image_report_dashboard_risk.href = report_dashboard_risk.toDataURL('image/png', 1)
      image_report_dashboard_equipment.href = report_dashboard_equipment.toDataURL('image/png', 1)
      image_report_dashboard_part.href = report_dashboard_part.toDataURL('image/png', 1)
      image_report_dashboard_status.href = report_dashboard_status.toDataURL('image/png', 1)
      image_report_dashboard_equipment_type.href = report_dashboard_equipment_type.toDataURL(
        'image/png',
        1
      )
      image_report_dashboard_month.href = report_dashboard_month.toDataURL('image/png', 1)
      image_dashboard_kritis.href = report_dashboard_kritis.toDataURL('image/png', 1)

      image_report_dashboard_risk.download = 'Chart Report Dashboard Risk.png'
      image_report_dashboard_equipment.download = 'Chart Report Dashboard Equipment.png'
      image_report_dashboard_part.download = 'Chart Report Dashboard Part.png'
      image_report_dashboard_status.download = 'Chart Report Dashboard Status.png'
      image_report_dashboard_equipment_type.download = 'Chart Report Dashboard Equipment Type.png'
      image_report_dashboard_month.download = 'Chart Report Dashboard Month.png'
      image_dashboard_kritis.download = 'Chart Dashboard Kritis.png'

      if (this.selectedEquipment == 0) {
        image_report_dashboard_risk.click()
        image_report_dashboard_equipment.click()
        image_report_dashboard_equipment_type.click()
      } else {
        image_report_dashboard_part.click()
      }

      image_report_dashboard_status.click()
      image_report_dashboard_month.click()
      image_dashboard_kritis.click()
    },

    async loadDataExport() {
      var self = this

      await this.timeout(100)
      ApiService.get(
        '/tsertifikasiperizinan/export?tahun=' +
          this.selectedYear +
          '&pabrik=' +
          this.selectedPabrik +
          '&equipment=' +
          this.selectedEquipment +
          '&plant=' +
          this.selectedPlant +
          '&nomor_serie=' +
          this.search.nomor_serie +
          '&lokasi=' +
          this.search.lokasi +
          '&unit_pengelola=' +
          this.search.unit_pengelola +
          '&area=' +
          this.search.area +
          '&retensi=' +
          this.search.retensi +
          '&pemeriksaan_terakhir=' +
          this.search.pemeriksaan_terakhir +
          '&masa_berlaku=' +
          this.search.masa_berlaku +
          '&hasil_resertifikasi=' +
          this.search.hasil_resertifikasi +
          '&keterangan=' +
          this.search.keterangan +
          '&nama_lokasi_sertifikasi_perizinan=' +
          this.search.nama_lokasi_sertifikasi_perizinan +
          '&program_resertifikasi=' +
          this.search.program_resertifikasi +
          '&exp_date=' +
          this.search.exp_date +
          '&sortBy=' +
          this.sortBy +
          '&sortDesc=' +
          this.sort_label
      )
        .then(({ data }) => {
          if (data.status === 'ok') {
            self.json_data.splice(0, self.json_data.length)
            data.data.forEach((row, index) => {
              self.json_data.push({
                no: index + 1,
                id_t_sertifikasi_perizinan: row.id_t_sertifikasi_perizinan,
                nomor_dokumen: row.nomor_dokumen,
                nama_dokumen: row.nama_dokumen,
                nama_kategori_peralatan: row.nama_kategori_peralatan,
                nomor_serie: row.nomor_serie,
                lokasi: row.lokasi,
                unit_pengelola: row.unit_pengelola,
                area: row.area,
                retensi: row.retensi,
                pemeriksaan_terakhir: row.pemeriksaan_terakhir,
                hasil_resertifikasi: row.hasil_resertifikasi,
                disahkan_oleh: row.disahkan_oleh,
                keterangan: row.keterangan,
                nama_lokasi_sertifikasi_perizinan: row.nama_lokasi_sertifikasi_perizinan,
                program_resertifikasi: row.program_resertifikasi,
                exp_date: row.exp_date,
              })
            })
            self.loading = false
          }
        })
        .catch((response) => {
          console.log(response)
        })
    },
  },
}
</script>
